<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">司机姓名</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.driverName"
          clearable
        >
        </el-input>
        <span class="fonints">车辆所有人</span>
         <el-input
          placeholder="请输入关键词"
          v-model="conditions.carowner"
          clearable
        >
        </el-input>
        <button class="buttons" @click="selectlist">查询</button>
      </div>
      <div class="componentSty_content_table">
        <el-table
          :data="arrlist.list"
          style="width: 100%; height: 80%"
           height="80%"
          @sort-change="sortchange"
        >
         <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column sortable="custom" prop="gmt_create" label="申请时间">
            <template v-slot="res">
              {{ dateFormat(res.row.gmtCreate) }}
            </template>
          </el-table-column>
          <el-table-column prop="plate" label="车牌号码"> </el-table-column>
          <el-table-column prop="hangPlate" label="挂车号码"> </el-table-column>
          <el-table-column prop="driverName" label="司机姓名">
          </el-table-column>
          <el-table-column prop="telephone" label="手机号码"> </el-table-column>
          <el-table-column prop="carowner" label="车辆所有人">
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span
                class="iconfont icon-qiyong"
                @click="passInfo(res.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list&&arrlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
            @current-change="getlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "会员管理" }, { name: "补卡申请" }],
      dropdownitemlist: ["第1页", "第2页", "第3页", "第4页", "第5页", "第6页"],
      conditions:{},
      timeout: null,
      arrlist: [],
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20
    };
    this.getlist();
  },
  methods: {
     ...mapMutations(["createConditions"]),
    dateFormat(obj) {
      if (!obj) return "";
      let dt = new Date(obj),
        yy = dt.getFullYear(),
        mon = (dt.getMonth() + 1 + "").padStart(2, 0),
        dd = (dt.getDate() + "").padStart(2, 0),
        hh = (dt.getHours() + "").padStart(2, 0),
        min = (dt.getMinutes() + "").padStart(2, 0);
      return `${yy}-${mon}-${dd} ${hh}:${min}`;
    },
    async getlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/driver/car/list",
        "get",
        this.conditions
      );
      if (!data || data.msg != "success")
        return this.$message.error("获取数据失败");
      this.arrlist = data.page;
    },
    async passInfo(val) {
      var obj = {};
      obj.useStatus = 5;
      obj.id = val.id;
      this.$messageBox
        .confirm("是否通过?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/driver/car/auditResult",
            "post",
            obj
          );
          if (!data || data.msg != "success")
            return this.$message.error("操作失败");
          this.$message.success("成功");
          this.getlist();
        })
        .catch(err=>err);
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getlist();
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getlist();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>